import type { HttpErrorResponse } from '@angular/common/http';

import type { CorrelationId, PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { PipelineTemplateItem } from '@core/pipeline-templates-types';
import type { PlacementMovement } from '@core/stages-types';

export interface SaveAsTemplatePayload {
  title: string;
  category: string;
  jobTemplateId: number;
}

export interface AssignToOfferPayload {
  jobTemplateId: number;
  pipelineTemplateId: number;
  placementsMovements?: PlacementMovement[];
}

const idSelector = ({ id }: { id: number }) => id;
const { actions, reducer } = createEntityCollectionStore<PipelineTemplateItem>()(
  'PipelineTemplateOfferTemplateItem',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchOne: (state, payload: { jobTemplateId: number; templateId: number }) =>
          defaultActions.fetchOne(state, { id: payload.templateId }),

        saveAsTemplate: (
          state,
          payload: { data: SaveAsTemplatePayload } & Required<CorrelationId>,
        ) => defaultActions.createOnePessimistic(state, payload),
        saveAsTemplateSuccess: (
          state,
          payload: { data: PipelineTemplateItem } & Required<CorrelationId>,
        ) => defaultActions.createOnePessimisticSuccess(state, payload),
        saveAsTemplateFailed: (
          state,
          payload: { error: HttpErrorResponse } & Required<CorrelationId>,
        ) => defaultActions.createOnePessimisticFailed(state, payload),

        assignTemplateToJobTemplate: (state, payload: AssignToOfferPayload) => state,
        assignTemplateToJobTemplateSuccess: (state, payload: { data: PipelineTemplateItem }) =>
          state,
        assignTemplateToJobTemplateFailed: (state, payload: { error: HttpErrorResponse }) => state,
      };
    },
  },
);

const PipelineTemplateJobTemplateItemActions: PickActions<
  typeof actions,
  'fetchOne' | 'saveAsTemplate' | 'assignTemplateToJobTemplate'
> = actions;

export {
  PipelineTemplateJobTemplateItemActions,
  reducer as PipelineTemplateJobTemplateItemReducer,
};
